import * as React from 'react';

import { FormSkeleton } from '@europrocurement/flexy-components';

/**
 * Skeleton de chargement des formulaires de configuration (offres & comptabilité).
 *
 * Mutualisé par toutes les fiches (Offre, Package, Catalogue, Champ complémentaire,
 * Groupement, Article, Catégorie d'article) et les formulaires multi-étapes, pour
 * un état de chargement cohérent.
 */
const LoadingScreen: React.FunctionComponent = function () {
    return (
        <FormSkeleton
            showTabs={false}
            sections={['identité', 'paramètres', 'options']}
            sx={{ height: 'auto' }}
        />
    );
};

export default LoadingScreen;
